<lib-modal
  [visible]="visible()"
  [title]="'modules.embedDialog.title' | translate"
  [contentTemplate]="resolvedTemplate ?? undefined"
  [saveText]="'modules.embedDialog.add' | translate"
  [cancelText]="'modules.embedDialog.cancel' | translate"
  [disabled]="!canApply()"
  (save)="onApply()"
  (cancel)="onCancel()"
  (visibleChange)="visible.set($event)"
></lib-modal>

<ng-template #embedContent>
  <div class="med">
    <p class="med__subtitle">{{ 'modules.embedDialog.subtitle' | translate }}</p>

    <mat-form-field appearance="fill" class="med__search">
      <mat-label>{{ 'modules.embedDialog.searchPlaceholder' | translate }}</mat-label>
      <input matInput [value]="searchTerm()" (input)="onSearch($event)" />
    </mat-form-field>

    @if (loading()) {
      <div class="med__loading">
        <mat-spinner diameter="28" />
      </div>
    } @else if (error()) {
      <p class="med__error" role="alert">{{ 'modules.embedDialog.loadError' | translate }}</p>
    } @else if (filtered().length === 0) {
      <p class="med__empty">{{ 'modules.embedDialog.empty' | translate }}</p>
    } @else {
      <ul class="med__list">
        @for (module of filtered(); track module.id) {
          <li class="med__item">
            <mat-checkbox
              [checked]="isSelected(module.id)"
              (change)="toggle(module.id)"
              [attr.aria-label]="('modules.embedDialog.selectAria' | translate) + ' ' + module.name"
            >
              <span class="med__row">
                <code class="med__id">{{ module.key }}</code>
                <span class="med__name">{{ module.name }}</span>
              </span>
            </mat-checkbox>
          </li>
        }
      </ul>
    }
  </div>
</ng-template>
